import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorPage } from '@/components/errors';

const badRequestErrorSearchSchema = z.object({
  message: z.string().optional(),
  stack: z.string().optional(),
});

export const Route = createFileRoute('/error/400')({
  component: BadRequestErrorPage,
  validateSearch: badRequestErrorSearchSchema,
});

function BadRequestErrorPage() {
  const { message, stack } = Route.useSearch();

  return <ErrorPage status={400} message={message} stack={stack} />;
}
